export class FileName {
    name: string;
    extension: string;
    patientId: string;
    analysisId: string;
}